import type {EventRuleGroup} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {portfoliosActions, portfoliosSelectors, appSelectors} from '@/store'
import {prop} from 'ramda'
import Rule from './rule'
import {getTranslatedTooltip, getAlertByRuleCode} from '@/rules-helper'
import {globalRuleTooltip} from '@/defaults'
import {prependRulesIndexerString} from '../../../store/portfolios/util'

type Props = {
  globalRules: EventRuleGroup,
  portfolioCountries: Array<string>,
}

const GLOBAL_COUNTRY = 'XX'
const GLOBAL_RULE_GROUP = prependRulesIndexerString('group', 1)

export class RawGlobalRules extends Component<Props> {
  handleChange = (change) =>
    this.props.changeEventRule(
      GLOBAL_COUNTRY,
      1,
      change,
      0,
      false
    )

  render = () => {
    let r = this.props.globalRules[GLOBAL_RULE_GROUP]
    const {l, portfolioCountries} = this.props
    const lang = this.props.langCode
    // r = prop('notificationRules', this.props.globalRules[GLOBAL_RULE_GROUP])
    return r && r.rules
      ? (
        <div className="rules">
          <div className="row">
            <div className="col-md-8 left-panel">
              <Rule
                rule={prop('notificationRules', r)['rule101']}
                onChange={this.handleChange}
                tooltip={getTranslatedTooltip(lang, l, globalRuleTooltip.rule101)}
                alert={getAlertByRuleCode('rule101', portfolioCountries)}
              />
              <Rule
                rule={prop('notificationRules', r)['rule102']}
                onChange={this.handleChange}
                tooltip={getTranslatedTooltip(lang, l, globalRuleTooltip.rule102)}
                alert={getAlertByRuleCode('rule102', portfolioCountries)}
              />
            </div>
            <div className="col-md-4 right-panel">
              <Rule
                rule={prop('notificationRules', r)['rule104']}
                onChange={this.handleChange}
                tooltip={getTranslatedTooltip(lang, l, globalRuleTooltip.rule104)}
                alert={getAlertByRuleCode('rule104', portfolioCountries)}
              />
              <Rule
                rule={prop('notificationRules', r)['rule105']}
                onChange={this.handleChange}
                tooltip={getTranslatedTooltip(lang, l, globalRuleTooltip.rule105)}
                alert={getAlertByRuleCode('rule105', portfolioCountries)}
              />
              <Rule
                rule={prop('notificationRules', r)['rule107']}
                onChange={this.handleChange}
                tooltip={getTranslatedTooltip(lang, l, globalRuleTooltip.rule107)}
                alert={getAlertByRuleCode('rule106', portfolioCountries)}
              />
              <Rule
                rule={prop('notificationRules', r)['rule106']}
                onChange={this.handleChange}
                tooltip={getTranslatedTooltip(lang, l, globalRuleTooltip.rule106)}
                alert={getAlertByRuleCode('rule107', portfolioCountries)}
              />
              <Rule
                rule={prop('notificationRules', r)['rule108']}
                onChange={this.handleChange}
                tooltip={getTranslatedTooltip(lang, l, globalRuleTooltip.rule108)}
                alert={getAlertByRuleCode('rule108', portfolioCountries)}
              />
              <Rule
                rule={prop('notificationRules', r)['rule109']}
                onChange={this.handleChange}
                tooltip={getTranslatedTooltip(lang, l, globalRuleTooltip.rule109)}
                alert={getAlertByRuleCode('rule109', portfolioCountries)}
              />
            </div>
          </div>
        </div>
      )
      : null
  }
}

const mapStateToProps = (state) => ({
  globalRules: portfoliosSelectors.getActivePortfolioGlobalRules(state),
  l: appSelectors.getL(state),
  langCode: state.app.user.preferredLanguageCode,
  portfolioCountries: portfoliosSelectors.getActivePortfolioCountries(state),
})

export default connect(
  mapStateToProps,
  portfoliosActions,
)(RawGlobalRules)



// WEBPACK FOOTER //
// ./src/views/settings-page/rules/global-rules.js